import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

import { getEntityTranslation } from "@/helpers";
import { DriverLicenseClassDto } from "@api/driver-license-class-dto";
import { DriverLicenseOccupationalCompetenceDto } from "@api/driver-license-occupational-competence-dto";
import { PermitAndCardTrainingDto } from "@api/permit-and-card-training-dto";
import { PermitAndCardTrainingOccupationalCompetenceDto } from "@api/permit-and-card-training-occupational-competence-dto";
import _ from "lodash";
import { computed, type PropType, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OccupationalCompetenceSelect',
  props: {
	valueMulti: {
		type: Array as PropType<any[]>,
	},
	options: {
		type: Array as PropType<DriverLicenseClassDto[] | PermitAndCardTrainingDto[]>,
		default: () => [],
	},
	type: {
		type: String as PropType<"DrivingLicense" | "PermitAndCard">,
	},
	isInvalid: {
		type: Boolean,
		required: false,
		default: undefined,
	},
},
  emits: ["update:valueMulti", "blur"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const cUnselectedOptions = computed(() => {
	if (props.type == "DrivingLicense") {
		return props.options
			.filter((x) => !isSelected(x))
			.map(
				(x) =>
					({
						driverLicenseClassId: x.id,
						driverLicenseClass: x,
						hasOccupationalCompetence: false,
						hasOccupationalCompetenceUntil: null,
					} as DriverLicenseOccupationalCompetenceDto)
			);
	} else if (props.type == "PermitAndCard") {
		return props.options
			.filter((x) => !isSelected(x))
			.map(
				(x) =>
					({
						permitAndCardTrainingId: x.id,
						permitAndCardTraining: x,
						hasOccupationalCompetence: false,
						hasOccupationalCompetenceUntil: null,
					} as PermitAndCardTrainingOccupationalCompetenceDto)
			);
	} else return [];
});

const isSelected = (dto: DriverLicenseClassDto | PermitAndCardTrainingDto) => {
	if (props.type == "DrivingLicense")
		return props.valueMulti?.some(
			(x: DriverLicenseOccupationalCompetenceDto) => x.driverLicenseClassId == dto.id
		);
	if (props.type == "PermitAndCard")
		return props.valueMulti?.some(
			(x: PermitAndCardTrainingOccupationalCompetenceDto) => x.permitAndCardTrainingId == dto.id
		);
};

const isAvailableOption = (
	dto: DriverLicenseOccupationalCompetenceDto | PermitAndCardTrainingOccupationalCompetenceDto
) => {
	if (props.type == "DrivingLicense")
		return props.options?.some(
			(x: DriverLicenseClassDto) =>
				x.id == (dto as DriverLicenseOccupationalCompetenceDto).driverLicenseClassId
		);
	if (props.type == "PermitAndCard")
		return props.options?.some(
			(x: PermitAndCardTrainingDto) =>
				x.id == (dto as PermitAndCardTrainingOccupationalCompetenceDto).permitAndCardTrainingId
		);
};

const cValues = computed({
	get: () => (props.valueMulti || []).concat(cUnselectedOptions.value),
	set: (
		value:
			| DriverLicenseOccupationalCompetenceDto[]
			| PermitAndCardTrainingOccupationalCompetenceDto[]
	) => {
		cValues.value = value;
	},
});

watch(
	() => props.options,
	() => {
		updateValue(cValues.value);
	},
	{ deep: true }
);

const updateValue = (
	values:
		| DriverLicenseOccupationalCompetenceDto[]
		| PermitAndCardTrainingOccupationalCompetenceDto[]
) => {
	console.log(values);
	emit(
		"update:valueMulti",
		values.filter((x) => x.hasOccupationalCompetence && isAvailableOption(x))
	);
};

const cOrderedValuesDrivingLicense = computed(() => {
	if (props.type == "DrivingLicense") {
		return _.orderBy(
			cValues.value as DriverLicenseOccupationalCompetenceDto[],
			(x) => x.driverLicenseClass.order
		);
	}

	return [];
});

const cOrderedValuesPermitAndCard = computed(() => {
	if (props.type == "PermitAndCard") {
		return _.orderBy(cValues.value as PermitAndCardTrainingOccupationalCompetenceDto[], [
			(x) => x.permitAndCardTraining.order,
			(x) => x.permitAndCardTraining.technicalName,
		]);
	}

	return [];
});

return (_ctx: any,_cache: any) => {
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_HakoDatePicker = _resolveComponent("HakoDatePicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.type == 'DrivingLicense')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(cOrderedValuesDrivingLicense.value, (value) => {
          return (_openBlock(), _createElementBlock("div", {
            key: value.driverLicenseClassId,
            class: "single-row m-0"
          }, [
            _createTextVNode(_toDisplayString(_unref(getEntityTranslation)(value.driverLicenseClass.translations, "name")) + " ", 1),
            _createVNode(_component_HakoCheckbox, {
              inline: "",
              modelValue: value.hasOccupationalCompetence,
              "onUpdate:modelValue": ($event: any) => ((value.hasOccupationalCompetence) = $event),
              onBlur: _cache[0] || (_cache[0] = ($event: any) => (updateValue(cValues.value))),
              class: "ms-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_HakoBsIcon, {
              class: "duration-arrow me-2",
              size: 150,
              icon: "arrow-right"
            }),
            _createVNode(_component_HakoDatePicker, {
              modelValue: value.hasOccupationalCompetenceUntil,
              "onUpdate:modelValue": ($event: any) => ((value.hasOccupationalCompetenceUntil) = $event),
              allowEmpty: "",
              "force-utc-midnight": ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]))
        }), 128))
      : _createCommentVNode("", true),
    (__props.type == 'PermitAndCard')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(cOrderedValuesPermitAndCard.value, (value) => {
          return (_openBlock(), _createElementBlock("div", {
            key: value.permitAndCardTrainingId,
            class: "single-row m-0"
          }, [
            _createTextVNode(_toDisplayString(_unref(getEntityTranslation)(value.permitAndCardTraining.translations, "name")) + " ", 1),
            _createVNode(_component_HakoCheckbox, {
              inline: "",
              modelValue: value.hasOccupationalCompetence,
              "onUpdate:modelValue": ($event: any) => ((value.hasOccupationalCompetence) = $event),
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (updateValue(cValues.value))),
              class: "ms-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_HakoBsIcon, {
              class: "duration-arrow me-2",
              size: 150,
              icon: "arrow-right"
            }),
            _createVNode(_component_HakoDatePicker, {
              modelValue: value.hasOccupationalCompetenceUntil,
              "onUpdate:modelValue": ($event: any) => ((value.hasOccupationalCompetenceUntil) = $event),
              allowEmpty: "",
              "force-utc-midnight": ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}
}

})